var map = {
	"./abacus.png": "b366",
	"./alembic.png": "e682",
	"./anime.png": "bd0c",
	"./apple.png": "f466",
	"./astrology.png": "381f",
	"./badminton.png": "feb4",
	"./bag.png": "c8a2",
	"./banana.png": "9714",
	"./basketball.png": "77ab",
	"./bento.png": "f29b",
	"./bitcoin.png": "958c",
	"./book.png": "102a",
	"./books.png": "9777",
	"./boom.png": "808b",
	"./borido.png": "9811",
	"./box.png": "8680",
	"./brain.png": "7ef8",
	"./c-plus-plus.png": "73ec",
	"./car.png": "e060",
	"./cash.png": "76ba",
	"./chartdecrease.png": "d779",
	"./china.png": "697a",
	"./chocolate.png": "f8dd",
	"./city.png": "bf9a",
	"./corgi.png": "63b1",
	"./couch.png": "0a54",
	"./cube.png": "6d47",
	"./desktop.png": "a9b3",
	"./detective.png": "9e87",
	"./donut.png": "c349",
	"./faceinclouds.png": "7c2f",
	"./faucet.png": "b340",
	"./finances.png": "25fd",
	"./freedom.png": "7141",
	"./friedegg.png": "1081",
	"./game.png": "d170",
	"./gamepad.png": "f491",
	"./hanafuda.png": "c59b",
	"./headphones.png": "20f0",
	"./hole.png": "ffee",
	"./icecream.png": "b885",
	"./incredible.png": "8b0e",
	"./instruments.png": "1b11",
	"./kiss.png": "faf7",
	"./kitty.png": "e9b0",
	"./leaf.png": "20f6",
	"./lotus.png": "48a7",
	"./magister.png": "215c",
	"./magnifier.png": "f496",
	"./meditation.png": "cd4e",
	"./melody.png": "45d4",
	"./moai.png": "7b9c",
	"./movie.png": "b41d",
	"./museum.png": "9a89",
	"./music.png": "248c",
	"./needle.png": "4667",
	"./note.png": "d3c9",
	"./notebook.png": "a707",
	"./notes.png": "91d6",
	"./paella.png": "ba72",
	"./palette.png": "b5d7",
	"./parachute.png": "4426",
	"./piano.png": "74ff",
	"./pickaxe.png": "0bf6",
	"./pierog.png": "3a87",
	"./popcorn.png": "5fee",
	"./postlove.png": "d191",
	"./potato.png": "94c9",
	"./python.png": "98ce",
	"./run.png": "8a55",
	"./scooter.png": "55e2",
	"./shoes.png": "8641",
	"./shopping.png": "e15f",
	"./shower.png": "851b",
	"./skateboard.png": "81d4",
	"./skull.png": "74e2",
	"./smile.png": "6a19",
	"./snowboard.png": "4f7c",
	"./snowflake.png": "ccf6",
	"./soap.png": "7039",
	"./star.png": "b2ed",
	"./starsky.png": "be37",
	"./subway.png": "c9c4",
	"./sun.png": "e608",
	"./sunrise.png": "e22f",
	"./swap.png": "b8e7",
	"./tape.png": "61ba",
	"./taxi.png": "4105",
	"./tea.png": "01d1",
	"./teapot.png": "6d475",
	"./theatre.png": "70e1",
	"./thread.png": "27d9",
	"./tiktok.png": "4057",
	"./tvbox.png": "e9d6",
	"./van.png": "83ea",
	"./walk.png": "d32b",
	"./wheel.png": "14b6",
	"./wine.png": "628c",
	"./wolf.png": "47d5",
	"./work.png": "cf04"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b60";